export const ASSOONASPOSSIBLEDELIVERYDATE = '01-01-2500';
